<script setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false
  },
  placeholder: {
    type: String
  },
  icon: {
    type: Object
  },
  showSubmit: {
    type: Boolean,
    default: true
  }
})

const emit = defineEmits(['submit', 'focus', 'blur'])

const model = defineModel()
</script>

<template>
  <div class="input-container flex items-center rounded-md justify-between w-full h-[40px]">
    <input v-model="model" :disabled="props.disabled" class="grow px-4 py-2 rounded-l-full bg-transparent focus:outline-none"
           @focus="emit('focus')" @blur="emit('blur')"
           :placeholder="props.placeholder">
    <button class="focus:outline-none bg-gray-500 p-2 search-button h-[100%] w-[40px] rounded-r-md" :click="emit('submit', model)" v-if="props.showSubmit">
      <FontAwesomeIcon :fixedWidth="true" :icon="props.icon" class="text-white m-auto" />
    </button>
  </div>
</template>


<style lang="scss" scoped>
@import '@/assets/styles/components/ui/input_with_submit_icon.scss';
</style>
